import React from 'react';
import PropTypes from 'prop-types';

import MapChunk from '../MapChunk';

// Simplified MapLevel - only renders levelOther
// Units and places are now rendered via PureSvgRenderer as pure markup
const MapLevel = React.memo(({
  levelOtherSvgData,
}) => {
  return (
    <g className="svgMap__shapes">
      {/* levelOther - other SVG elements for this level */}
      { levelOtherSvgData && (
        <MapChunk markupString={levelOtherSvgData} />
      )}
      {/* Placeholder to prevent empty SVG group issues */}
      {' '}
    </g>
  );
});

MapLevel.propTypes = {
  levelOtherSvgData: PropTypes.string,
};

MapLevel.defaultProps = {
  levelOtherSvgData: null,
};

export default MapLevel;
